/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All conversions run in your browser — nothing is uploaded. Once the page is loaded it keeps working without sending any data.`)
};

const es_uc_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las conversiones se ejecutan en tu navegador — nada se carga. Una vez que la página está cargada, sigue funcionando sin enviar datos.`)
};

const de_uc_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Umrechnungen laufen in Ihrem Browser — nichts wird hochgeladen. Sobald die Seite geladen ist, funktioniert sie weiter, ohne Daten zu senden.`)
};

const nl_uc_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle conversies worden in uw browser uitgevoerd — niets wordt geüpload. Nadat de pagina is geladen, blijft het werken zonder gegevens te verzenden.`)
};

const fr_uc_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les conversions s'exécutent dans votre navigateur — rien n'est téléchargé. Une fois la page chargée, elle continue à fonctionner sans envoyer aucune donnée.`)
};

const it_uc_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le conversioni vengono eseguite nel tuo browser — nulla viene caricato. Una volta caricata la pagina continua a funzionare senza inviare alcun dato.`)
};

const pt_br2_uc_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as conversões são executadas no seu navegador — nada é enviado. Depois que a página é carregada, ela continua funcionando sem enviar nenhum dado.`)
};

const pt_uc_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as conversões executam no seu navegador — nada é carregado. Após a página ser carregada, continua a funcionar sem enviar qualquer dado.`)
};

const ja_uc_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての変換はブラウザで実行されます — データはアップロードされません。ページが読み込まれた後、データを送信せずに動作し続けます。`)
};

const zh_uc_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_hub_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_hub_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_hub_faq2_a", locale)
	if (locale === "en") return en_uc_hub_faq2_a(inputs)
	if (locale === "es") return es_uc_hub_faq2_a(inputs)
	if (locale === "de") return de_uc_hub_faq2_a(inputs)
	if (locale === "nl") return nl_uc_hub_faq2_a(inputs)
	if (locale === "fr") return fr_uc_hub_faq2_a(inputs)
	if (locale === "it") return it_uc_hub_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_hub_faq2_a(inputs)
	if (locale === "pt") return pt_uc_hub_faq2_a(inputs)
	if (locale === "ja") return ja_uc_hub_faq2_a(inputs)
	return zh_uc_hub_faq2_a(inputs)
};